import React, { useContext, useState, useEffect, useRef } from 'react'
import UserManage from './UserManage'
import { useHistory } from 'react-router-dom'

import Layout from '@/product/components/templates/Layout'

const UserAdd = (props) => {
    const history = useHistory()

    const cancelSubmit = () => {
        history.goBack()
    }

    return (
        <Layout>
            <div className="addUserModal page">
                <div className="fspBody">
                    <UserManage
                        cancelFunction={cancelSubmit}
                        action={props.action}
                        userStatus={'new'}
                    />
                </div>
            </div>
        </Layout>
    )
}

export default UserAdd
